module.exports = __webpack_public_path__ + "3aa5f813f2da8a94cce0bb45bb5b04ca.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-22.png
// module id = 2257
// module chunks = 0